import { DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import MDButton from 'components/MDButton';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch } from 'react-redux';
import { openSnackbar } from '../../../redux/slices/common';
import { closeCustomModalDialog } from '../../../redux/slices/modalSlice';
import { addProductStrains, getInfoAndEffect } from '../../../redux/slices/hyperwolf/products';
import { addOrUpdateStrain } from '../../../redux/slices/hyperwolf/strains';

export default function AddNewStrainModalHw({ closeModal }) {
  const { modalData, isLoading = false } = useSelector(state => state.modal);
  const dispatch = useDispatch()
  const { fetchProductStrainsData = () => { } } = modalData

  const [infoEffectData, setInfoEffectData] = useState([])
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await dispatch(getInfoAndEffect()).unwrap();
        setInfoEffectData(res);
      } catch (error) {
      }
    };
    fetchData();
  }, [dispatch]); // Add dispatch to the dependency array

  const [formData, setFormData] = useState({
    strainName: '',
    strainCategory: ''
  })

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    })
  }

  const showError = (message, errorType) => {
    if (errorType === 'success') {
      dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
    }
    if (errorType === 'error') {
      dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
    }
  };

  const handleSave = () => {
    dispatch(addOrUpdateStrain({ data : {...formData, productId: modalData.productId}  })).unwrap()
      .then(res => {
        showError(res.message, 'success')
        dispatch(closeCustomModalDialog());
        fetchProductStrainsData();
      }).catch((err) => {
        showError(err?.message, 'error');
      })
  }


  return (
    <>
      <DialogTitle id='draggable-dialog-title' display='flex' alignItems='center' justifyContent='space-between'>
        Add New Strain
        <IconButton onClick={closeModal} edge='end' size='small'>
          <CloseIcon fontSize='medium' />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Grid container alignItems="center" spacing={1} pt={1}>
            <Grid item xs={12} sm={12} md={6}>
              <TextField
                name="strainName"
                label="Strain Name"
                value={formData.strainName}
                onChange={handleInputChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Strain Category*</InputLabel>
                <Select
                  className='form-select'
                  //   error={Boolean(errors?.strainCategory)}
                  onChange={handleInputChange} label='Strain Category*' name='strainCategory' value={formData.strainCategory}>
                  {
                    infoEffectData?.map((infoStrain => {
                      return <MenuItem key={infoStrain.strainType} value={infoStrain.strainType}>{infoStrain?.strainType}</MenuItem>;
                    }))
                  }
                </Select>
                {/* {Boolean(errors?.strainCategory) && <FormHelperText error>{errors?.strainCategory}</FormHelperText>} */}
              </FormControl>
            </Grid>
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions className='footer-modal' style={{ marginBottom: "12px" }}>
        <MDButton
          onClick={closeModal}
          sx={{ minWidth: '160px' }}
          type='button'
          variant='outlined'
          color='dark'
        >
          Cancel
        </MDButton>
        <MDButton
          onClick={handleSave}
          sx={{ minWidth: '160px' }}
          color="primary"
          type='button'
          variant='contained'
        >
          Save
        </MDButton>
      </DialogActions>
    </>
  );
}